import { render, staticRenderFns } from "./PhotoLightbox.vue?vue&type=template&id=a7efa856&"
import script from "./PhotoLightbox.vue?vue&type=script&lang=js&"
export * from "./PhotoLightbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports